import {Button, ButtonProps} from 'antd';
import {CSSProperties, PropsWithChildren, ReactNode} from 'react';

import {Locale} from '../../provider/locale/locale';
import {LangKeyType} from '../../provider/locale/translation/type';

type FooterButtonConfigType = ButtonProps & {
    langKeyType: LangKeyType;
};

type PropsType = {
    leftFooterButtonConfig?: FooterButtonConfigType;
    rightFooterButtonConfig?: FooterButtonConfigType;
    footer?: ReactNode;
};

const footerStyle: CSSProperties = {
    alignItems: 'center',
    display: 'flex',
    gap: 12,
    justifyContent: 'space-between',
    marginTop: 24,
};

const rightGroupStyle: CSSProperties = {
    alignItems: 'center',
    display: 'flex',
    gap: 12,
    marginLeft: 'auto',
};

const contentStyle: CSSProperties = {
    minHeight: 320,
};

// Shared multi-step wizard frame for the promotions & events forms (mirrors the stories step layout).
export function PublicationWizardStep(props: PropsWithChildren<PropsType>): JSX.Element {
    const {leftFooterButtonConfig, rightFooterButtonConfig, footer, children} = props;

    const {langKeyType: leftButtonLangKey, ...leftButtonProps} = leftFooterButtonConfig || {};
    const {langKeyType: rightButtonLangKey, ...rightButtonProps} = rightFooterButtonConfig || {};

    return (
        <div>
            <div style={contentStyle}>{children}</div>

            <div style={footerStyle}>
                {leftButtonLangKey ? (
                    /* eslint-disable-next-line react/jsx-props-no-spreading */
                    <Button {...leftButtonProps}>
                        <Locale stringKey={leftButtonLangKey} />
                    </Button>
                ) : (
                    <span />
                )}

                <div style={rightGroupStyle}>
                    {footer || null}

                    {rightButtonLangKey && (
                        /* eslint-disable-next-line react/jsx-props-no-spreading */
                        <Button type="primary" {...rightButtonProps}>
                            <Locale stringKey={rightButtonLangKey} />
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
}
